var canvas, canvas2, text, fontSize, fontFamily, fSize, activeCOLOR, newText, zoom, cWidth = 724, cHeight = 1024,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, array = [], get_data, sizeCrop,
    scale_factor, newheight, leftOb, imageUrl,
    placeholderimg1, placeholderimg2, placeholderimg3,
    placeholderimg4,img,
    leftMarker, rightMarker, vLine;

var loader = jQuery('#customLoader'),
    cropper = "", canvas, boxWidth, boxLeft, boxTop,
    croppedSize, orientations, aspectRatio, reCroper,
    c1img1;

var outLine,sizeBmW = 715, sizeBmH = 450,
    sizeB1W = 443, sizeB1H = 443,
    sizeB2W = 250, sizeB2H = 63;

imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');

$(document).ready(function() {

  currentImage = null; 

  function loadImage(url) {
    if (currentImage) {
      canvas2.remove(currentImage);
    }
    fabric.Image.fromURL(url, function(img) {
      img.set({
        left: halfWidth,
        top: halfHeight,
        selectable: false
      });
      // img.scale(.6);
      canvas2.add(img);
      currentImage = img; 
      img.sendToBack();
      // window['text1Page'].bringToFront();
      canvas2.renderAll();
    }, { crossOrigin: 'anonymous' });
  }

  var defaultUrl = $('#base1 img').attr('data-src');
  if(defaultUrl) {
    loadImage(defaultUrl);
  }

  
  // On style change
  jQuery(document).on('change', 'input[name="Style"]', function(e) {
    var selectedVal = $(this).val();

    if (selectedVal === 'Without Base (Height 9 Width 6 inches)') {
      var blackUrl = $('#base1 img').attr('data-src');
      loadImage(blackUrl);
    } else {
      var woodenUrl = $('#base2 img').attr('data-src');
      loadImage(woodenUrl);
    }
  });

});


let frameImg = document.querySelector("#stylish_heart");
let simpleImage = new fabric.Image(frameImg, {
  left: 0,   
  top: 0,
  selectable: false
});
window['canvas2'] = new fabric.Canvas('canvas2', {
  width: cWidth,
  height: cHeight
});

window['canvas2'].add(simpleImage);
simpleImage.sendToBack();
addModify(window['canvas2']);




//-------------- Heart Calendar --------------

const dayNames = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

var inputDate = '2023-10-15',
  calendarGroup;


const cellWidth = 40;
const cellHeight = 29;
const startX = 40;
const startY = 140;


//var svgEl = document.body.getElementsByTagName('svg')[0];
var svgEl = document.getElementById('heart_cIcon');
var serializer = new XMLSerializer();
var svgStr = serializer.serializeToString(svgEl);

var path,outline;

// Function to generate the calendar
document.getElementById('calendar-date').addEventListener('input', () => {
    const inputDate = document.getElementById('calendar-date').value;
    window['canvas2'].remove(calendarGroup);
    drawCalendar(inputDate);
});

function drawCalendar(inputDate){
    if (!inputDate) {
        alert('Please select a date.');
        return;
    }

    const selectedDate = new Date(inputDate);
    const year = selectedDate.getFullYear();
    const month = selectedDate.getMonth();
    const selectedDay = selectedDate.getDate();

    calendarGroup = new fabric.Group([], {
        left: 0,
        top: 0,
      fill:'rgba(0,0,0,0)',
        selectable: true
    });

    // Get the first and last days of the month
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);

    const firstDayOfWeek = firstDay.getDay();
    const totalDays = lastDay.getDate();

    // Add month and year title
    // const monthTitle = new fabric.Text(`${firstDay.toLocaleString('default', { month: 'long' })}`, {
    //     left: 175,
    //     top: 55,
    //     fontSize: 30,
    //     fontFamily: 'Poppins',
    //     textAlign: 'center',
    //     originX: 'center',
    //     fill:'#fff'
    // });
    // //canvas.add(monthTitle);
    // calendarGroup.addWithUpdate(monthTitle);


  const monthYearTitle = new fabric.Text(
  `${firstDay.toLocaleString('default', { month: 'long' })}`, {
    left: 175,
    top: 68,
    fontSize: 20,
    fontFamily: 'Galada',
    textAlign: 'center',
    originX: 'center',
    fill: '#fff'
  }
);
calendarGroup.addWithUpdate(monthYearTitle);
  
    // Draw day names
    dayNames.forEach((day, index) => {
        const dayText = new fabric.Text(day, {
            left: startX + index * cellWidth + cellWidth / 2,
            top: 110,
            fontSize: 18,
            fontFamily: 'Poppins',
            textAlign: 'center',
            originX: 'center',
            fill:'#000'
        });
        calendarGroup.addWithUpdate(dayText);
    });

    // Draw calendar grid and add dates
    let currentDay = 1;
    for (let row = 0; row < 6; row++) {
        for (let col = 0; col < 7; col++) {
            const x = startX + col * cellWidth;
            const y = startY + row * cellHeight;

            // Draw rectangle
            const rect = new fabric.Rect({
                left: x,
                top: y,
                width: cellWidth,
                height: cellHeight,
                fill: 'transparent',
                //stroke: '#ccc',
                //strokeWidth: 1,
                //selectable: false
            });
            //canvas.add(rect);
            calendarGroup.addWithUpdate(rect);

            // Add date text if within the valid range
            if (row === 0 && col < firstDayOfWeek || currentDay > totalDays) {
                continue;
            }

            // Highlight the selected date
            if (currentDay === selectedDay) {
                const highlight = new fabric.Rect({
                    left: x,
                    top: y,
                    width: cellWidth,
                    height: cellHeight,
                    //fill: 'rgba(255, 223, 186, 0.6)',
                    selectable: false
                });
                //canvas.add(highlight);
                //canvas.bringToFront(rect);
                path = fabric.loadSVGFromString(svgStr,function(objects, options) {
                    var obj = fabric.util.groupSVGElements(objects, options);
                    obj.scaleToHeight(32).set({
                        left: x-1,
                        top: y-3
                    }).setCoords();
                    //canvas.add(obj).renderAll();
                    calendarGroup.addWithUpdate(obj);
                });
            }

            const dateText = new fabric.Text(currentDay.toString(), {
                left: x + cellWidth / 2,
                top: y + cellHeight / 2,
                fontSize: 19,
                fontFamily: 'Poppins',
                textAlign: 'center',
                originX: 'center',
                originY: 'center',
                fill: currentDay === selectedDay ? '#fff' : '#000',
                selectable: false
            });
            //canvas.add(dateText);
            calendarGroup.addWithUpdate(dateText);

            currentDay++;
        }
    }
    calendarGroup.scaleToWidth(355);
    calendarGroup.left = 370;
    calendarGroup.top = 881;
    window['canvas2'].add(calendarGroup);
    calendarGroup.bringToFront();
};

drawCalendar(inputDate);


window['placeholderimg1'] = new fabric.Rect({
  left: 372.5,
  top: 278.5,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0)'
});

window['canvas2'].add(window['placeholderimg1']);
// window['placeholderimg1'].sendToBack();
window['canvas2'].renderAll();


var heartimg,heartBorder,imgRatio,clipRatio,clipWidth = 443;
    heartPathString = "M370 125c0 66.3-53.7 120-120 120s-120-53.7-120-120S183.7 5 250 5s120 53.7 120 120Z";
var heartClip = new fabric.Path(heartPathString, {
  left: 372.5,
  top: 278.5,
  originX: 'center',
  originY: 'center',
  flipY: true,
  fill: 'transparent',
  absolutePositioned: true
});
heartClip.scaleToWidth(clipWidth);

canvas2.add(heartClip);
// heartClip.sendToBack();

document.getElementById('image_upload_first').addEventListener('change',function(e){
  canvas = window['canvas2'];
  img = window['placeholderimg1'];
  available_height = img.height;
  sizeCrop = '1';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  readURL2(e.target,'#image1');
});


// Load the image and apply the clipPath
fabric.Image.fromURL('https://cdn.shopify.com/s/files/1/0796/4452/4821/files/anniversary_placeholder.png?v=1741253729', function(heartimg){
  heartimg.set({ crossOrigin: 'anonymous' });
  heartimg.set({
    left: 372.5,
    top: 278.5,
    originX: 'center',
    originY: 'center',
    selectable: false,
    clipPath: heartClip
  });

  // heartimg.scaleToWidth(clipWidth);
  canvas2.add(heartimg);
  heartimg.sendToBack();

  heartBorder = new fabric.Path(heartPathString, {
    left: 372.5,
    top: 278.5,
    originX: 'left',
    originY: 'top',
    fill: 'transparent',
    flipY: true,
    stroke: 'red',
    strokeWidth: 0,
    selectable: false
  });
  heartBorder.scaleToWidth(clipWidth);
  // canvas2.add(heartBorder);
  canvas2.renderAll();
}, { crossOrigin: 'anonymous' });


window['text1Page'] = new fabric.Text('Happy Anniversary',{
  left: halfWidth,
  top: 610,
  fontSize: 55,
  fontFamily: 'Galada',
  fill: 'red',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

var fontName = window['text1Page'].fontFamily;
jQuery('.choose_font').val("'" + fontName + "'").trigger('change');


window['canvas2'].add(window['text1Page']);

document.getElementById('text_1').addEventListener('focus', function () {
  if (window['text1Page'].text === 'Happy Anniversary') {
    window['text1Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});

function fitTextToWidth(textObj, maxWidth) {
  let fontSize = 55;
  textObj.set({ fontSize });

  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

document.getElementById('text_1').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text1Page'].set('text', newText);
  fitTextToWidth(window['text1Page'], 500);
  window['text1Page'].bringToFront();
  window['canvas2'].renderAll();
});


function canvasMakeImg(canvas,zoom){
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function canvasBlock(canvas){
  zoom = jQuery('.product__media-outer').width();
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function setZoomMask(canvas,newZoomLevel){
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width:  cWidth * newZoomLevel,
    height:  cHeight * newZoomLevel
  });
  canvas.renderAll();
}

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;
  canvas.on('selection:cleared', function(e){
    object = e.target;
  });

  canvas.on('object:removed',function(e){
    object = e.target;
  });

  canvas.on('object:added', function(e){
    object = e.target;
    addControls(object);
    canvas.renderAll();
  });
  
  canvas.on('object:modified', function(e){
    object = e.target;
    canvas.renderAll();
  });
  
  canvas.on('selection:created', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('selection:updated', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('object:scaling', function(e){
    canvas.renderAll();
  });

  jQuery(window).on('load',function(){
    canvasBlock(canvas);
  });

  jQuery(window).on('resize',function(){
    canvasBlock(canvas);
  });
}

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    selectable:false,
    originX:"center",
    originY:"center",
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#fff',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      withConnection: true,
      cornerSize: 18,
    });
  };
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}

function renderIcon(icon) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

function deleteHandler(eventData,transform){
  var target = transform.target;
  activeOb = canvas.getActiveObject();
  canvas.remove(activeOb);
  canvas.renderAll();
}

initCropper();

function readURL2(input,bImg){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  if(cropper == ""){
  }else {
    cropper.destroy();
  }
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      jQuery('#blah').attr('src', e.target.result);
      reCroper.attr('data-img',e.target.result);
      jQuery(bImg).val(e.target.result);
      // simpleImage.bringToFront();
    };
    reader.readAsDataURL(input.files[0]);
    setTimeout(initCropper, 2500);
  }
}

function addImage(e,placeholderimg,canvas){
  var file = e.target.files[0];
  var reader = new FileReader();
  reader.onload = function(event){
    var imgObj = new Image();
    imgObj.src = event.target.result;
    imgObj.onload = function(){
      var img = new fabric.Image(imgObj);
      img.set({
        left: placeholderimg.left,
        top: placeholderimg.top,
        selectable:true,
        scaleX: placeholderimg.width / img.width,
        scaleY: placeholderimg.height / img.height,
        clipPath: new fabric.Rect({
          width: img.width,
          height: img.height,
          rx: 20, // Apply border radius from placeholder
          ry: 20
        })
      });
    };
  };
  reader.readAsDataURL(file);
}

function addCroppedImg(imgurl){
  canvas.remove(img).renderAll();
  canvas.remove(heartimg).renderAll();
  fabric.Image.fromURL(imgurl, function(heartimg) {
    heartimg.set({ crossOrigin: 'anonymous' });
    heartimg.set({
      left: 372.5,
      top: 278.5,
      originX: 'center',
      originY: 'center'
    });
    heartimg.scaleToHeight(available_height);
    heartimg.clipPath = heartClip;
    // heartimg.set({ left: 290, top: 300});
     canvas2.add(heartimg);
     // canvas2.sendToBack(heartimg);
    simpleImage.bringToFront();
    calendarGroup.bringToFront();
    console.log(heartimg);
    canvas2.renderAll();
  }, { crossOrigin: 'anonymous' });
  
}



function initCropper(){
  var image = document.getElementById('blah');
  cropper = new Cropper(image, {
    viewMode: 1,
    dragMode: 'move',
    aspectRatio: sizeCrop,
    restore: false,
    guides: false,
    center: true,
    highlight: true,
    cropBoxMovable: true,
    cropBoxResizable: true,
    toggleDragModeOnDblclick: false,
    data:{}
  });
  jQuery('.popupImg').show();
  jQuery('#tadaWidget').addClass('hidden');
  loader.addClass('hidden');
}

document.getElementById('crop_button').addEventListener('click', function(){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  var imgurl =  cropper.getCroppedCanvas().toDataURL();
  addCroppedImg(imgurl);
  setTimeout(function(){
    reCroper.parent().removeClass('hidden');
    jQuery('.popupImg').hide();
    loader.addClass('hidden');
    jQuery('#tadaWidget').removeClass('hidden');
  },500);
});


document.getElementById('zoom_out').addEventListener('click', function(){
  cropper.zoom(-0.1);
});

document.getElementById('zoom_in').addEventListener('click', function(){
  cropper.zoom(0.1);
});

document.getElementById('reset_button').addEventListener('click', function(){
  cropper.reset();
});

document.getElementById('cancelCropper').addEventListener('click', function(){
  jQuery('.popupImg').hide();
  jQuery('#tadaWidget').removeClass('hidden');
});

jQuery(document).on('click','.btnReCrop', function(){
  loader.removeClass('hidden');
  imgurl = jQuery(this).attr('data-img');
  sizeCrop = jQuery(this).attr('data-ratio');
  img = window[jQuery(this).attr('data-obj')];
  canvas = window[jQuery(this).attr('data-canvas')];
  available_height = jQuery(this).attr('data-height');
  console.log(canvas);
  jQuery('#tadaWidget').addClass('hidden');
  setTimeout(function(){
    cropper.destroy();
    jQuery('#blah').attr('src',imgurl);
    initCropper();
    jQuery('.popupImg').show();
    loader.addClass('hidden');
  },150);
});

jQuery('.customColors').each(function(){
  colorBox = jQuery(this).attr('id');
  loadColorPicker(colorBox);
});

jQuery(document).on('change','.fontFamily',function(){
  var fontID = jQuery(this).attr('data-canvas');
  fontSize = '';
  activeCOLOR = '';
  fontFamily = jQuery(this).val();
  canvas = window[fontID];
  updateFont(window['text1Page'],fontFamily,fontSize,activeCOLOR);
  updateFont(window['text2Page'],fontFamily,fontSize,activeCOLOR);
  window['text1Page'].bringToFront();
});


function loadColorPicker(colorBox){
  jQuery('#'+colorBox).colorpicker({
    inline: true,
    container: true,
    extensions:[{
      name: 'swatches',
      options:{
        colors:{
          'tetrad1': 'transparent',
          'tetrad2': '#e30405',
          'tetrad3': '#197b30',
          'tetrad4': '#0054a5',
          'tetrad5': '#ffcc00',
          'tetrad6': '#f6ebbe',
          'tetrad7': '#ffea00',
          'tetrad8': '#f8931d',
          'tetrad9': '#f499c2',
          'tetrad10': '#959595',
          'tetrad11': '#fef335',
          'tetrad12': '#a0400d',
          'tetrad13': '#000000',
          'tetrad14': '#604973',
          'tetrad15': '#afe8fc',
          'tetrad16': '#fffafa',
          'tetrad17': '#bc8cbe',
          'tetrad18': '#ff69b4',
          'tetrad19': '#93278f',
          'tetrad20': '#009987',
          'tetrad21': '#0af447',
          'tetrad22': '#00008b',
          'tetrad23': '#006400'
        },
        namesAsValues: false
      }
    }],
    template: '<div class="colorpicker">' +
      '<div class="colorpicker-saturation"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-hue"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-alpha">' +
      '   <div class="colorpicker-alpha-color"></div>' +
      '   <i class="colorpicker-guide"></i>' +
      '</div>' +
      '<div class="colorpicker-bar">' +
      '   <a href="javascript:void(0);" class="button btn-block colorOFF">Ok</a>'+
      '   <div class="ctn-icon-eyedropper dropper-eyedrop"><svg class="icon icon-eyedropper" viewBox="0 0 16 16">'+
      '   <path d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5'+
      '   0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207'+
      '   1.207 0 0 0 0-1.708zM2 12.707l7-7L10.293 7l-7 7H2z"/></svg></div>'+
      '</div>' +
      '</div>'
  }).on('colorpickerCreate', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('id'),
        active = colorBox.find('.currentColor');
      activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
    },200);
  }).on('colorpickerChange', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('data-canvas'),
          textOb = colorBox.attr('data-obj'),
          active = colorBox.find('.currentColor');
      activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
      colorBox.attr('data-color',activeCOLOR);
      
      fontFamily = '';
      fontSize = '';
      canvas = window[colorID];
      updateFont(window['text1Page'],fontFamily,fontSize,activeCOLOR);
      updateFont(window['text2Page'],fontFamily,fontSize,activeCOLOR);
    },200);
  });
  jQuery(document).on('click','.colorBox',function(){
    jQuery('.colorBox').each(function(){
      jQuery(this).next().hide();
    });
    jQuery(this).next().show();
  });
  jQuery(document).on('click','.colorOFF',function(){
    var parENt = jQuery(this).parent().parent(),
        toolBarBox = parENt.parent().parent().parent().attr('id');
    if(toolBarBox === 'labelBase'){
      parENt.parent().parent().parent().parent().removeClass('active');
    }else{
      parENt.hide();
    }
  });
}

function updateFont(activeOb,family,size,fill){
  if(activeOb){
    if(family == ''){
      family = activeOb.fontFamily;
    }
    if(size == ''){
      size = activeOb.fontSize;
    }
    if(fill == ''){
      fill = activeOb.fill;
    }
    sCAle = activeOb.scaleX;
    activeOb.set('fontSize',size);
    activeOb.set('fontFamily',family);
    window['text1Page'].bringToFront();
    activeOb.set('fill',fill);
    activeOb.scaleX = .5;
    activeOb.setCoords();
    canvas.renderAll();
    activeOb.scaleX = sCAle;
    activeOb.setCoords();
    canvas.renderAll();
  }
}

jQuery(document).on('click','.dropper-eyedrop',function(){
  const eyeDropper = new EyeDropper();
  eyeDropper.open().then(result => {
    jQuery(this).parent().parent().parent().colorpicker('setValue', result.sRGBHex);
  }).catch(e => {
    console.error(e);
  });
});


async function handleUpload(fileInputs,timeID){
  const temp_images = [];

  temp_images.push(jQuery('#crop_button').attr('data-cropped'));
  
  for (let input of fileInputs){
    const file = input.files[0]; // Only first file per input
    if(file){
      const base64 = await toBase64(file); // ✅ now safely inside async
      temp_images.push(base64);
    }
  }
  if(temp_images.length === 0){
    alert("Please select at least one image.");
    return;
  }
  const payload = {
    timeId: timeID,
    temp_images: temp_images
  };
  console.log(payload);
  try {
    const response = await fetch('//technology-architects.com/tasweer-modules/upload_client_img.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    
    const result = await response.json();
    console.log("Upload result:", result);
    var int = 1;
    result.uploaded_images.forEach(img => {
      if(jQuery('#image'+int).length < 1){
        jQuery('#preview').append('<input type="hidden" id="image'+int+'" name="properties[User Upload '+int+']">');
      }
      if (img.status === "success") {
        jQuery('#image'+int).val(img.image_url);
        int += 1;
      } else {
        console.warn("Upload failed:", img.error);
      }
    });
    jQuery('.product-form__buttons .product-form__submit').removeAttr('disabled').trigger('click');
    loader.addClass('hidden');
  } catch (error) {
    console.error("Upload error:", error);
    alert("Upload failed.");
  }
}

// ✅ Convert a file to base64 string
function toBase64(file){
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}


/* fetch Call */
var size,thumbnail;
var loadedObject,selectDate,enterquote,chooseFont,additionalInfo,wMark,svgMrk;
let pdfData = {};
jQuery(document).on('click','#download',function(){
  loader.removeClass('hidden');
  setTimeout(function(){
    const id = ['canvas2'];
    const canvas = window['canvas2'];
    size = 350;
    loadMark(id,canvas,size);
    size = 4000;
    removeMark(canvas,size);
    // hideExtras(canvas);
    canvas.remove(currentImage);
    window['canvas2'] = canvas.toDataURL('image/png');
    selectDate = jQuery('.calendar-date input').val();
    enterquote = jQuery('.enter_quote input').val();
    chooseFont = jQuery('.choose_font option:selected').val();
    additionalInfo = jQuery('.tShirtImg textarea').val();
    // showExtras(canvas);
    canvasBlock(canvas);
    console.log(window['canvas2']);
    fetch('//technology-architects.com/tasweer-modules/save_order.php',{
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body:  JSON.stringify({
        temp_image: window['canvas2t'],
        original_image: window['canvas2']
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      var previewId = data[0],
          extraImg1 = data[1];
      jQuery('#previewImg').val(previewId);
      jQuery('#preExtraImg').val(extraImg1);
      jQuery('#selectDate').val(selectDate);
      jQuery('#enterquote').val(enterquote);
      jQuery('#chooseFont').val(chooseFont);
      jQuery('#addInfo').val(additionalInfo);
      console.log('Server response:', data);
      // jQuery('.product-form__buttons .product-form__submit').trigger('click');
      const fileInputs = document.querySelectorAll('.upload_image input[type="file"]');
      handleUpload(fileInputs,previewId);
    })
    .catch(error => console.error('Error uploading images:', error));
  },100);
});

function loadMark(id,canvas,size){
  wMark = document.getElementById('wm_collage');
  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function(objects,options){
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.bringToFront();
    loadedObject.setCoords();
    canvas.remove(currentImage);
    canvas.renderAll();
  });
  canvasMakeImg(canvas,size);
  window[id+'t'] = canvas.toDataURL('image/png');
  console.log(window[id+'t']);
}

function removeMark(canvas,size){
  canvas.remove(loadedObject).renderAll();
  canvasMakeImg(canvas,size);
}